"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// drawing helpers
// -------------------------------
var LEFT = 1;
var RIGHT = 2;
var TOP = 3;
var BOTTOM = 4;
var NEAR = 10;
var FAR = 20;

function line(context, from_x, from_y, to_x, to_y, color, width, line_cap, dash, alpha) {
  context.beginPath();
  context.strokeStyle = color;
  context.lineWidth = width;
  context.lineCap = line_cap || 'butt';

  if (dash) {
    context.setLineDash(dash);
  }

  if (alpha !== undefined) {
    context.globalAlpha = alpha;
  }

  context.moveTo(from_x, from_y);
  context.lineTo(to_x, to_y);
  context.stroke();
  context.closePath();
  context.setLineDash([]);
  context.globalAlpha = 1;
}

function circle(context, x, y, radius, fill, stroke, stroke_width, start_angle, end_angle, move_before_path) {
  var start = start_angle === undefined || start_angle === null ? 0 : start_angle;
  var end = end_angle === undefined || end_angle === null ? 2 * Math.PI : end_angle;

  if (move_before_path) {
    context.moveTo(x, y);
  }

  context.beginPath();

  if (!move_before_path) {
    context.moveTo(x, y);
  }

  context.fillStyle = fill || 'transparent';
  context.strokeStyle = stroke || 'transparent';
  context.lineWidth = stroke_width;
  context.arc(x, y, radius, start, end);
  context.fill();
  context.stroke();
  context.closePath();
}

function text(context, text, x, y, color, font, h_align, v_align, measure) {
  if (!measure) {
    context.beginPath();
  }

  context.fillStyle = color;
  context.font = font;
  context.textAlign = h_align || 'left';
  context.textBaseline = v_align || 'bottom';

  if (measure) {
    return context.measureText(text);
  }

  context.fillText(text, x, y);
  context.closePath();
}

function rect(context, x, y, w, h, color) {
  context.beginPath();
  context.moveTo(x, y);
  context.rect(x, y, w, h);
  context.fillStyle = color;
  context.fill();
  context.closePath();
}

function round_rect(context, x, y, w, h, radius, color) {
  context.beginPath();
  context.moveTo(x + radius, y);
  context.arcTo(x + w, y, x + w, y + radius, radius);
  context.arcTo(x + w, y + h, x + w - radius, y + h, radius);
  context.arcTo(x, y + h, x, y + h - radius, radius);
  context.arcTo(x, y, x + radius, y, radius);
  context.fillStyle = color;
  context.fill();
  context.closePath();
}

function popup_box(context, x, y, w, h, canvas_w, canvas_h, radius, color, measure, stroke_color) {
  var _bounds;

  // draw a popup box focused on (x,y) - i.e. with a 'pointer triangle' pointing to that point
  var triangle_height = radius * 1.35;
  var triangle_width = radius * 2.2;
  var triangle_hpos__near = w / 3.5;
  var triangle_hpos__far = w - triangle_hpos__near;
  var triangle_vpos__near = h / 4;
  var triangle_vpos__far = triangle_vpos__near; // Calculate bounds

  function inside_canvas(xy) {
    return xy.x >= 0 && xy.x + w < canvas_w && xy.y >= 0 && xy.y + h < canvas_h;
  }

  var bounds = (_bounds = {}, _defineProperty(_bounds, TOP + NEAR, {
    x: x - triangle_hpos__near,
    y: y + triangle_height
  }), _defineProperty(_bounds, TOP + FAR, {
    x: x - triangle_hpos__far,
    y: y + triangle_height
  }), _defineProperty(_bounds, BOTTOM + NEAR, {
    x: x - triangle_width / 2 - triangle_hpos__far,
    y: y - triangle_height - h
  }), _defineProperty(_bounds, BOTTOM + FAR, {
    x: x - triangle_width / 2 - triangle_hpos__near,
    y: y - triangle_height - h
  }), _defineProperty(_bounds, LEFT + NEAR, {
    x: x + triangle_height,
    y: y - triangle_width / 2 - triangle_vpos__far
  }), _defineProperty(_bounds, LEFT + FAR, {
    x: x + triangle_height,
    y: y - triangle_width / 2 - triangle_vpos__near
  }), _defineProperty(_bounds, RIGHT + NEAR, {
    x: x - triangle_height - w,
    y: y - triangle_width / 2 - triangle_vpos__near
  }), _defineProperty(_bounds, RIGHT + FAR, {
    x: x - triangle_height - w,
    y: y - triangle_width / 2 - triangle_vpos__far
  }), _bounds);

  var _ref = function (_) {
    return inside_canvas(bounds[TOP + NEAR]) ? [TOP, NEAR] : inside_canvas(bounds[TOP + FAR]) ? [TOP, FAR] : inside_canvas(bounds[BOTTOM + NEAR]) ? [BOTTOM, NEAR] : inside_canvas(bounds[BOTTOM + FAR]) ? [BOTTOM, FAR] : inside_canvas(bounds[LEFT + NEAR]) ? [LEFT, NEAR] : inside_canvas(bounds[LEFT + FAR]) ? [LEFT, FAR] : inside_canvas(bounds[RIGHT + NEAR]) ? [RIGHT, NEAR] : [RIGHT, FAR];
  }(),
      _ref2 = _slicedToArray(_ref, 2),
      pointer_side = _ref2[0],
      pointer_near_far = _ref2[1];

  bounds = Object.assign(bounds[pointer_side + pointer_near_far], {
    pointer_side: pointer_side
  });

  if (measure) {
    return bounds;
  } // Draw


  function draw_vertical_triangle(px, py, direction) {
    var k = direction === TOP ? 1 : -1;
    context.lineTo(px - triangle_width / 2, py + k * triangle_height);
    context.lineTo(px, py);
    context.lineTo(px + triangle_width / 2, py + k * triangle_height);
  }

  function draw_horizontal_triangle(px, py, direction) {
    var k = direction === LEFT ? 1 : -1;
    context.lineTo(px + k * triangle_height, py - triangle_width / 2);
    context.lineTo(px, py);
    context.lineTo(px + k * triangle_height, py + triangle_width / 2);
  }

  context.beginPath();
  context.moveTo(bounds.x + radius, bounds.y);

  if (pointer_side === TOP) {
    draw_vertical_triangle(x, y, pointer_side);
  }

  context.arcTo(bounds.x + w, bounds.y, bounds.x + w, bounds.y + radius, radius);

  if (pointer_side === RIGHT) {
    draw_horizontal_triangle(x, y, pointer_side);
  }

  context.arcTo(bounds.x + w, bounds.y + h, bounds.x + w - radius, bounds.y + h, radius);

  if (pointer_side === BOTTOM) {
    draw_vertical_triangle(x, y, pointer_side);
  }

  context.arcTo(bounds.x, bounds.y + h, bounds.x, bounds.y + h - radius, radius);

  if (pointer_side === LEFT) {
    draw_horizontal_triangle(x, y, pointer_side);
  }

  context.arcTo(bounds.x, bounds.y, bounds.x + radius, bounds.y, radius);
  context.fillStyle = color;
  context.fill();
  context.closePath();

  if (stroke_color && pointer_side !== BOTTOM) {
    var stroke_width = 4 * context.canvas.pixel_ratio;
    var y_stroketop = bounds.y + h - stroke_width;
    context.save();
    context.shadowColor = 'transparent';
    context.beginPath();
    context.moveTo(bounds.x, bounds.y + h - radius);
    context.arcTo(bounds.x, bounds.y + h, bounds.x + radius, bounds.y + h, radius);
    context.arcTo(bounds.x + w, bounds.y + h, bounds.x + w, bounds.y + h - radius, radius);
    context.arcTo(bounds.x + w, y_stroketop, bounds.x + radius, y_stroketop, radius - 1);
    context.arcTo(bounds.x, y_stroketop, bounds.x, bounds.y + h - radius, radius - 1);
    context.fillStyle = stroke_color, context.fill();
    context.closePath();
    context.restore();
  }

  return bounds;
}

var _default = {
  line: line,
  circle: circle,
  text: text,
  rect: rect,
  round_rect: round_rect,
  popup_box: popup_box
};
exports["default"] = _default;